import { useState, useEffect, useMemo } from 'react';
import MainPremium from "../components/MainPremium";
import Questions from '../components/Questions';

const ResultsOffer = ({
  client,
  product,
  subGroup,
  validationErrors,
  setValidationErrors,
  inputRefs,
  handleInputBlur,
  language,
  setQuestions,
  firstLevelArea,
  secondLevelArea,
  subArea,
  inputBlurTriggered,
  savingQuestionId,
  fetchAreaNames,
  subIndex,
  onPremiumChange, 
 
}) => {
  
const [insAMValue, setInsAMValue] = useState(null); // D_INS_AM tracked state
  const [isProductActive, setIsProductActive] = useState(false); // D_PRODUCT_ACTIVE tracked state

  const insAMCurrent = useMemo(() => {
    return subGroup.subAreaCompositionDtoList.find(q => q.code === 'D_INS_AM')?.value ?? null;
  }, [subGroup.subAreaCompositionDtoList]);

  const productActiveCurrent = useMemo(() => {
    return subGroup.subAreaCompositionDtoList.find(q => q.code === 'D_PRODUCT_ACTIVE')?.value ?? false;
  }, [subGroup.subAreaCompositionDtoList]);

  useEffect(() => {
    setInsAMValue(insAMCurrent);
  }, [insAMCurrent]);

  useEffect(() => {
    setIsProductActive(productActiveCurrent);
  }, [productActiveCurrent]);


    return (
    <div>
      {subGroup.subAreaCompositionDtoList.map((question) => {
        return (
          <div 
            key={question.uniqueId} 
            className={`entry ${question.compositionType} ${question.uniqueId}`}
          >                       
            <Questions
               key={question.uniqueId}
               question={question}
               validationErrors={validationErrors}
               setValidationErrors={setValidationErrors}
               inputRefs={inputRefs}
               setQuestions={setQuestions}
               handleInputBlur={handleInputBlur}
               firstLevelArea={firstLevelArea}
               subArea={subArea}
               secondLevelArea={secondLevelArea}
               inputBlurTriggered={inputBlurTriggered}
               savingQuestionId={savingQuestionId}
               fetchAreaNames={fetchAreaNames}
               client={client}
               product={product}
               language={language}
            />
          </div>
        );
      })}

      <div className={`other-products-premium ${isProductActive ? 'active-product' : ''}`}>
        <MainPremium
          key={`main-premium-${subIndex}`}
          client={client}
          product={product}
          subIndex={subIndex}
          productId={subGroup.productId}
          refreshTrigger={insAMValue}
          onPremiumChange={onPremiumChange}
          isProductActive={isProductActive}
          inputBlurTriggered={inputBlurTriggered}
        /> 
      </div>
    </div> 
  );
};

export default ResultsOffer;
